@if (useStandard) {
  <crm-standard-single-select
    [descriptorApiUrl]="descriptorUrl"
    [selectedValue]="selectedUnit"
    (selectedValueChange)="onSelected($event)"
    [class]="class"
    [styleClass]="styleClass"
    [showClear]="showClear"
    [disabled]="disabled"
    [isError]="isError"
    [appendTo]="appendTo"></crm-standard-single-select>
} @else {
  <crm-single-select
    [options]="units"
    [selectedItem]="selectedUnit"
    (selectedItemChange)="onSelected($event)"
    [showClear]="showClear"
    [styleClass]="styleClass"
    [class]="class"
    [appendTo]="appendTo"
    [disabled]="disabled"
    [isError]="isError"
    [loading]="loading"></crm-single-select>
}
